import { createSlice, PayloadAction, createAsyncThunk  } from '@reduxjs/toolkit'
import { getProductsImages, getRequestedProducts } from '../../../../utils/requestsUtils/functionsRequests/products/productsFunctions'
import moment from 'moment'

export type TypeProduct = "DIGITAL" | "PHYSICAL"
export type StatusProduct = "REQUESTED" | "VALIDATED" | "REJECTED"


type ProductImageCommonData = {
    id:             string
    typeProduct:    TypeProduct
    userId:         string
    productName:    string
    description:    string
    date:      string
    price?:          number
}

export type DigitalProduct = {
    fileType:       string[]
    typeProduct:    "DIGITAL"
} & ProductImageCommonData

export type PhysicalProduct = {
    typeProduct:    "PHYSICAL"
} & ProductImageCommonData

export type ProductImageDB = DigitalProduct | PhysicalProduct


export const GetProductsImagesThunk = createAsyncThunk(
    'productsImages/GetProductsImagesThunk',
    async () => {
      try { 

          const { items } = await getProductsImages()
    
          return {
            items,
          }
      } catch (error) {
          console.log("error", error)
          return {
            items: []
          }
      }
    }
)


const initialState = {
    loading: false,
    productsImages: [] as ProductImageDB[]
}

export const ProductsImagesSlice = createSlice({
    name: 'products',
    initialState,
    reducers: {

        removeProductImagesReducer: (state, action: PayloadAction<string>) => {
            const productId = action.payload
            state.productsImages = state.productsImages.filter((product) => product.id !== productId)
            return state
        },
        resetProductsImagesReducer: () => {
            return initialState
        }
    },

    extraReducers: (builder) => {
        builder.addCase(GetProductsImagesThunk.fulfilled, (state, action: PayloadAction<{ items: ProductImageDB[] }>) => {
            const { items } = action.payload  
            items.sort((a,b) => {
                if(new Date(a.date).getTime() > new Date(b.date).getTime())
                    return 1
                else
                    return -1
            })
            state.productsImages = items
            state.loading = false
            return state
        }).addCase(GetProductsImagesThunk.pending, (state, action: any) => {
            state.loading = true
            return state     
        }).addCase(GetProductsImagesThunk.rejected, (state, action: any) => {
            return initialState
        })
    },

});

// Action creators are generated for each case reducer function
export const {  
    removeProductImagesReducer,
  resetProductsImagesReducer,
} = ProductsImagesSlice.actions

export default ProductsImagesSlice.reducer